import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const PRO48_IMAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_pickle-trainer-v1/artifacts/q7ez005c_17A28E49-9419-43E4-BEA3-1A862D0F5223.png";

export default function Pro48Spotlight() {
  return (
    <section id="pro-48" className="relative py-24 md:py-36 bg-[#070707] border-y border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="rounded-3xl overflow-hidden border border-white/10 bg-[#0a0a0a] aspect-[4/3]">
            <img
              src={PRO48_IMAGE}
              alt="Pickle Wall™ PRO 48 Outdoor Pickleballs packaging with ATP ZONE branding, official product photography"
              className="w-full h-full object-contain"
              loading="lazy"
            />
          </div>
          <div>
            <div className="inline-flex items-center gap-2 mb-5 px-3 py-1.5 rounded-full bg-white/10 border border-white/20">
              <Clock size={12} className="text-white/70" />
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/70">Coming Soon</span>
            </div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF6B00] mb-3">Every Touch Matters.™</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-balance leading-[0.95]">
              Introducing Pickle Wall<span className="text-[#FF6B00]">™</span> PRO 48
            </h2>
            <p className="mt-6 text-lg text-white/70 max-w-lg">
              Our 48-hole outdoor pickleball is being developed as part of the Pickle Wall training ecosystem.
            </p>
            <Link
              to="/shop"
              data-testid="pro48-learn-more"
              onClick={() => trackEvent("cta_click", { button_text: "View PRO 48", button_location: "home-pro48" })}
              className="mt-8 group inline-flex items-center gap-2 glass text-white font-bold uppercase tracking-wider text-sm px-7 py-4 hover:bg-white/10 transition-colors"
            >
              View PRO 48
              <ArrowRight size={16} className="text-[#FF6B00] group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
